"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeUnits = void 0;
/**
 * All time units as an array.
 */
exports.timeUnits = ["year", "month", "day", "hour"];
